<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ChromeSpeechToTextTextarea
        rows="4"
        max-rows="10"
        v-model="evolution.text"
      />
      <ErrorsMessages :errors="errors" />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <ConfirmationDialog
        certificate
        headerClass="modal-header"
        message-title="FINALIZAR?"
        :message-body="`Deseja realmente finalizar a evolução?`"
        open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
        open-class="btn-notcertified"
        open-left-icon="fa-check"
        @yes="finish"
        :loading="loading"
        :disabled="loading"
      />
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import BRyHUB from "../../lib/BRy/hub";

export default {
  name: "Duplicate",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    evolution: Object,
  },

  data() {
    return {
      loading: false,
      errors: [],
    };
  },

  methods: {
    async finish() {
      try {
        this.loading = true;

        const {
          evolution: { resident_id, text, type },
        } = this;

        let params = {
          resident_id,
          text,
          type,
        };

        const response = await api.post("/rest-home/evolution", params);

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.text = "";
          this.errors = [];

          await BRyHUB.authorize({ id, table: "evolution" });
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
